import React from 'react';
import { isEqual } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withLocalize, Translate } from 'react-localize-redux';
import { Circles } from "../../common/loadingComponent";
import { getParams } from '../../common/utils';
import { MomentDate } from '../../common/momentComponent';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { apiGet, getHostApi, getHostUrl } from '../../../store/apiWrapper';
import Money from '../../common/moneyComponent';
import RelationLink from '../../reportSections/relations/relationLink';
import RedSemaphore from '../../../img/icons/RedSemafor';
import GreenSemaphore from '../../../img/icons/GreenSemafor';
import YellowSemaphore from '../../../img/icons/YellowSemafor';
import NoDataComponent from '../../common/noDataComponent';
import UnderlinedTitle from "../../common/underlinedTitle";
import Message from "../../common/message";

class Result extends React.Component {
    mounted = false;

    state = {
        data: null,
        params: null,
        isLoading: true,
        error: null
    }

    render() {
        if (this.state.isLoading)
            return <Circles />

        if (this.state.error) {
            var message = <Translate id="UnhappyUser.InternalServerError" options={{ renderInnerHtml: true }} />

            if (this.state.error.data.error.message === "UnhappyUser.DatabaseErrorTimeout")
                message = this.props.translate("UnhappyUser.COI.DbTimeout");
            else if (this.state.error.data.error.message)
                message = this.props.translate(this.state.error.data.error.message);

            return <div style={{ paddingTop: '1em' }}>
                <Message type="error" message={message} />
            </div>
        }

        if (!this.state.data)
            return <NoDataComponent />

        return (
            <div className='card card-special' >
                <div className='card-body'>
                    <UnderlinedTitle header={this.props.translate("ConflictOfInterest.Result.CheckResults")} marginBottom />
                    {!isNullOrUndefined(this.state.data) && !isNullOrUndefined(this.state.data.notFoundFile) && this.state.data.notFoundFile !== "" &&
                        <a className="link-internal" href={`${getHostUrl()}/files/conflict-of-interest/file/${this.state.data.notFoundFile}`} target="_blank">
                            <Translate id="ConflictOfInterest.Result.VerifiedSubjectsNotLinked" />
                        </a>
                    }
                    {!isNullOrUndefined(this.state.data) && !isNullOrUndefined(this.state.data.transactionId) && !isNullOrUndefined(this.state.data.items) && this.state.data.items.length > 0 &&
                        <a className="link-internal" href={`${getHostUrl()}/files/conflict-of-interest/xml/${this.state.data.transactionId}`} target="_blank">
                            <Translate id="ConflictOfInterest.Result.ExportIntoXml" />
                        </a>
                    }
                    <div style={{ float: 'right' }}><Translate id="ConflictOfInterest.Result.CheckedTo" />: <MomentDate value={new Date()} /></div>
                    {this.state.data.items.map((item, idx) => this.renderTable(item, idx))}
                </div>
            </div>
        )
    }

    componentDidMount() {
        this.mounted = true;
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "")
            this.getData(getParams(window.location.search));
    }

    componentDidUpdate() {
        if (this.mounted && !isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = getParams(window.location.search);
            if (!isEqual(this.state.params, params))
                this.getData(params);
        }
    }

    getData(params) {
        this.setState({ params: params });
        apiGet(`${getHostApi()}/api/conflict-of-interest/for-entity`, params,
            (r) => this.setState({ data: r.data, isLoading: false, error: null }),
            (e) => this.setState({ data: null, isLoading: false, error: e })
        );
    }

    renderTable = (item, idx) => {
        return <table className="table table-report-section" key={idx}>
            <thead>
                <tr>
                    <th><Translate id="ConflictOfInterest.Result.Semaphore" /></th>
                    <th><Translate id="ConflictOfInterest.Result.Level" /></th>
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th><Translate id="ConflictOfInterest.Result.Relation" /></th>
                    <th><Translate id="ConflictOfInterest.Result.Deposit" /></th>
                    <th><Translate id="ConflictOfInterest.Result.Currency" /></th>
                    <th><Translate id="ConflictOfInterest.Result.ValidFrom" /></th>
                    <th><Translate id="ConflictOfInterest.Result.ValidTo" /></th>
                </tr>
            </thead>
            <tbody>
                {item.items.map((row, i) => this.renderRow(row, i))}
            </tbody>
        </table>
    }

    renderRow = (item, idx) => {
        return (
            <tr key={idx}>
                <td>{this.renderSemaphore(item.subject.semaphoreCode)}</td>
                {this.renderArrow(item)}
                {this.renderSubjectName(item)}
                {item.level !== 0 &&
                    <>
                        <td>{item.relation.relationTypeDescription}
                            {item.relation.share &&
                                <>
                                    &nbsp;(<Money value={item.relation.share} fractionDigits={2} nullPlaceholder="-" />%)
                                </>
                            }
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}><Money value={item.relation.depositValue} fractionDigits={2} nullPlaceholder="-" /></td>
                        <td>{item.relation.currencyId}</td>
                        <td>{item.relation.startDateFormated}</td>
                        <td>{item.relation.endDateFormated}</td>
                    </>
                }
            </tr>)
    }

    renderSubjectName = (item) => {
        var colSpan = 10;
        if (item.level !== 0)
            colSpan = 5 - item.level;
        return <td colSpan={colSpan}>
            <div style={{ display: 'flex' }}>
                <RelationLink entityName={item.subject.fullName} entityId={item.subject.entityId} spanStyle={{ whiteSpace: 'pre-wrap' }}
                    reports={item.subject.reports} />
                <div>
                    {item.subject.ico && <>&nbsp;({item.subject.ico})</>}
                    {item.subject.birthDate && <>&nbsp;({item.subject.birthDateFormated})</>}
                </div>
            </div>
        </td>
    }

    renderArrow = (item) => {
        if (item.level === 0)
            return null;
        var direction = '';
        if (item.direction === 'Backward')
            direction = 'left';
        if (item.direction === 'Forward')
            direction = 'right';
        return <td colSpan={item.level} style={{ textAlign: 'right' }}><FontAwesomeIcon icon={`long-arrow-alt-` + direction} style={{ fontSize: "1.5em" }} /></td>
    }

    renderSemaphore = (code) => {
        if (code === undefined || code === null)
            return null;
        if (code === 1)
            return <GreenSemaphore className='size-1-5em' />
        else if (code === 2)
            return <YellowSemaphore className='size-1-5em' />
        else if (code === 3)
            return <RedSemaphore className='size-1-5em' />
        return null;
    }
}

export default withLocalize(Result);